module.exports = __webpack_public_path__ + "static/media/13.67d5c070.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/13.png
// module id = 1295
// module chunks = 0